import React from 'react';
import { Button, Icon } from 'rsuite';
import SelectPill from '../../../../../../components/SelectPill';
import SaveIcon from '@material-ui/icons/Save';
import { useOmnichannelStore } from '../../store/ModuloOmnichannel.store';
import { useOmnichannelGetSavedFilters } from '../../hooks/useOmnichannelGetSavedFilters';
import { useProductFilter } from '../../hooks/useProductFilter';
import { useFormContext } from 'react-hook-form';
import { OmnichannelSavedFiltersList } from '../../types';
import styles from './SaveFilters.module.scss';

export type SaveFiltersProps = {
  renderMenu: (menu: React.ReactNode) => React.ReactNode;
  onClickDeleteSavedFilter: () => void;
};

const SAVED_FILTERS_LOCALE = {
  noResultsText: 'Nenhum filtro encontrado',
  searchPlaceholder: 'Buscar filtro',
};

export const SaveFilters = ({ renderMenu, onClickDeleteSavedFilter }: SaveFiltersProps) => {
  const omnichannelRequestBody = useOmnichannelStore(state => state.omnichannelRequestBody);
  const omnichannelSavedFiltersSelectList = useOmnichannelStore(state => state.omnichannelSavedFiltersSelectList);
  const omnichannelSavedFiltersList = useOmnichannelStore(state => state.omnichannelSavedFiltersList);
  const selectedSavedFilter = useOmnichannelStore(state => state.selectedSavedFilter);
  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);
  const setOmnichannelSavedFiltersList = useOmnichannelStore(state => state.setOmnichannelSavedFiltersList);
  const resetRequestBody = useOmnichannelStore(state => state.resetRequestBody);

  const { handleGetSavedFiltersSearch } = useOmnichannelGetSavedFilters();
  const { productHandlers } = useProductFilter();
  const { setValue, reset } = useFormContext();

  const HAS_FILTER_SELECTED = (omnichannelRequestBody?.redes?.length ?? 0) > 0;

  const handleSelectSavedFilter = (id: number) => {
    const savedFilter = omnichannelSavedFiltersList.find((item: OmnichannelSavedFiltersList) => item.idFiltroSalvo === id);
    if (!savedFilter) return;

    productHandlers.onSearchProducts(savedFilter.gtins?.join(' ') ?? '');
    setOmnichannelSavedFiltersList(id);

    setOmnichannelState('selectedSavedFilter', savedFilter);

    const requestBody = {
      ...omnichannelRequestBody,
      gtins: savedFilter.gtins,
      redes: savedFilter.redes,
      semanas: savedFilter.semanas,
      ufs: savedFilter.ufs,
      cidades: savedFilter.cidades,
    };

    setOmnichannelState('omnichannelRequestBody', requestBody);

    setValue('produtos', savedFilter.gtins);
    setValue('redes', savedFilter.redes);
    setValue('periodoSemanas', savedFilter.semanas);
    setValue('uf', savedFilter.ufs);
    setValue('cidade', savedFilter.cidades);

    if ((savedFilter.gtins?.length ?? 0) > 0) {
      setValue('tipoGtin', 'ESPECIFICOS');
    } else {
      setValue('tipoGtin', 'TODOS');
    }

    const HAS_ALL_TERRITORY = savedFilter.ufs?.includes('TODO_TERRITORIO') ?? false;
    const HAS_CITIES = (savedFilter.cidades?.length ?? 0) > 0;
    const HAS_UFS = (savedFilter.ufs?.length ?? 0) > 0;

    if (HAS_UFS && HAS_ALL_TERRITORY) {
      setValue('tipoLocalizacao', 'TODO_TERRITORIO');
    } else if (HAS_CITIES) {
      setValue('tipoLocalizacao', 'CIDADE');
    } else if (HAS_UFS && !HAS_ALL_TERRITORY && !HAS_CITIES) {
      setValue('tipoLocalizacao', 'UF');
    }
  };

  const handleOnCleanSavedFilter = () => {
    resetRequestBody();
    setOmnichannelState('selectedSavedFilter', null);
    reset({
      tipoLocalizacao: 'TODO_TERRITORIO',
      produtos: [],
      periodoSemanas: 12,
      tipoGtin: 'TODOS',
      redes: [],
      cidade: [],
      uf: [],
    });
  };

  return (
    <div className={styles['save-filter-wrapper']}>
      <SelectPill
        type="select"
        id="select-picker-pill"
        placeholder="Filtros salvos"
        name="filtros-salvos"
        data={omnichannelSavedFiltersSelectList}
        onOpen={() => handleGetSavedFiltersSearch('')}
        onSearch={(value: string) => handleGetSavedFiltersSearch(value)}
        onSelect={(id: number) => handleSelectSavedFilter(id)}
        onClean={handleOnCleanSavedFilter}
        locale={SAVED_FILTERS_LOCALE}
        renderMenu={renderMenu}
      />
      {selectedSavedFilter?.idFiltroSalvo && (
        <Button className={styles['btn-delete-saved-filter']} color="red" onClick={onClickDeleteSavedFilter}>
          <Icon icon="trash2" />
        </Button>
      )}
      <Button
        id="save-omnichannel-filters"
        className={styles['btn-save-filters']}
        disabled={!HAS_FILTER_SELECTED}
        onClick={() => setOmnichannelState('showModalOmnichannelSaveFilters', true)}
      >
        <SaveIcon className={styles['save-icon']} />
        Salvar filtros
      </Button>
    </div>
  );
};
